import { FunctionComponent } from 'react';
import i18n from 'i18n';
import Wrapper from 'pages/password-reset/components/Wrapper';
import { EmailOutlined } from '@material-ui/icons';
import { useSearchParams } from 'react-router-dom';
import { Box, Button } from '@material-ui/core';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import validator from 'validator';
import toggleNotification from 'actions/notifications';
import toggleLoading from 'actions/default';
import BackToLogin from './components/BackToLogin';
import passwordResetStyles from './styles';
import { verifyEmail } from './actions';

const PasswordResetCheck: FunctionComponent = () => {
  const classes = passwordResetStyles();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');

  const dispatch = useDispatch();

  const onSave = () => {
    if (!email || !validator.isEmail(email)) {
      dispatch(
        toggleNotification(i18n.t('pages.signup.formError.email'), 'error')
      );
      return;
    }

    toggleLoading(true);
    verifyEmail(email)
      .then(() => {
        toggleLoading(false);
      })
      .catch(() => {
        toggleLoading(false);
        dispatch(toggleNotification(i18n.t('notifications.apiError'), 'error'));
      });
  };

  return (
    <Wrapper
      icon={<EmailOutlined />}
      title={i18n.t('pages.passwordReset.check.title')}
      subtitle={i18n.t('pages.passwordReset.check.subtitle')}
    >
      <Box className={clsx(classes.subtitle, classes.subtitleEmail)}>
        {searchParams.get('email')}
      </Box>
      <Box
        className={classes.subtitle}
        margin="auto"
        display="flex"
        alignItems="center"
      >
        {i18n.t('pages.passwordReset.check.noDelivery')}
        <Button variant="text" color="primary" onClick={() => onSave()}>
          {i18n.t('pages.passwordReset.check.resend')}
        </Button>
      </Box>
      <BackToLogin />
    </Wrapper>
  );
};

export default PasswordResetCheck;
